import * as ActionTypes from '../actions/projects'
import * as ProjectActionTypes from '../actions/project'

import { project as projectModel } from '$models/projects'

const initialState = {
  isLoading: false,
  projects: [],
  aggregations: null,
  next: null,
}

export const projects = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOAD_PROJECTS_SUCCESS:
      const next = action.response.meta && action.response.meta.next
      const newProjects = action.response.projects

      return {
        ...state,
        projects: [...state.projects, ...newProjects],
        next,
        isLoading: false,
      }

    case ActionTypes.LOAD_PROJECTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    case ActionTypes.LOAD_PROJECTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case ActionTypes.EMPTY_PROJECTS:
      return {
        ...state,
        projects: [],
        aggregations: null,
      }

    case ActionTypes.LOAD_SEARCHED_PROJECTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case ActionTypes.LOAD_SEARCHED_PROJECTS_SUCCESS: {
      if (action.response && !action.response.projects) {
        return {
          ...state,
          projects: [],
          aggregations: action.response.aggregations,
          isLoading: false,
        }
      }

      const projects =
        action.response && action.response.projects.map((project) => projectModel(action.config.lang)(project))
      const next = action.response.meta && action.response.meta.next

      return {
        ...state,
        projects: [...state.projects, ...projects],
        next,
        aggregations: action.response.aggregations,
        isLoading: false,
      }
    }

    case ActionTypes.LOAD_SEARCHED_PROJECTS_REQUEST:
      return {
        ...state,
        isLoading: false,
      }

    case ProjectActionTypes.UPDATE_PROJECT_SUCCESS: {
      const project = action.response
      const projects = state.projects.map((item) =>
        item.props.id === project.id
          ? projectModel(action.config.lang)({ ...item.props, ...project, manager: project.manager })
          : item
      )

      return {
        ...state,
        projects,
      }
    }

    case ProjectActionTypes.MODERATE_PROJECT_SUCCESS: {
      const project = action.response
      const projects = state.projects.map((item) =>
        item.props.id === project.id ? projectModel(action.config.lang)({ ...item.props, ...project }) : item
      )

      return {
        ...state,
        projects,
      }
    }

    default:
      return state
  }
}
